import Service from '../../Services/Service'

const FaqAPI = {
    getAllFaqs(lang) {
        return Service.get(`/faq/faq_by_category?lang=${lang}`);
    }
};

export default FaqAPI;
